import { init as primaryFooterPromoInit } from './primaryFooterPromoComponent';
import { init as secondaryFooterPromoInit } from './secondaryFooterPromoComponent';
import { init as stickyEmailSignUpInit } from '@core/js/components/stickyEmailSignUpComponent';
import { init as cookiesAlertInit } from '@core/js/components/cookiesAlertComponent';
import { init as privacyNoticeInit } from '@core/js/components/privacyNoticeComponent';
import addAccordionSupport from '../../../core/js/uiSupport/accordion';

import { launchAsyncEmailSignUpModal } from '../utils/asyncLaunchers';

import { generate, templateLocationExists } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import { getFlatNavigationSync } from '@core/js/utils/navigationUtils';

import Cookies from '../services/cookies';
import { COOKIE_NAME_COUNTRY } from '../constants';

import template from 'footer/core-footer.j2';

import {
    changeEmailOptinSource
} from '../actions/emailSignupActions';

import { clearUniqueVisitsCookie } from '../../../core/js/utils/cookieUtils';

import { extractCountryCodeFromFooterSiteURL } from '../utils/urlUtils';
import { getDefaultCurrencyForCountry } from '../sagas/currencySagas';
import { changeCurrency } from '../utils/currencyUtils';
import { error as logError } from '../utils/logger';

function optionallyAddAccordionSupport(store) {
    if(_.get(store.getState(), 'core.deviceCharacteristics.is_smallish', false) || _.get(store.getState(), 'core.deviceCharacteristics.is_medium', false)) {
        addAccordionSupport(this, this.templateLocation);
    }
}

function firstRender(store) {
    optionallyAddAccordionSupport.bind(this)(store);
}

export function init(store, overrides = {}) {
    const config = {
        children: [
            primaryFooterPromoInit,
            secondaryFooterPromoInit,
            stickyEmailSignUpInit,
            cookiesAlertInit,
            privacyNoticeInit
        ],
        templateLocation: '.dom-footer',
        isComponentValid: templateLocationExists,
        name: 'footerComponent',
        attachEvents: attachEvents,
        firstRender: firstRender,
        afterRender: afterRender,
        onStateChange: onStateChange,
        watch: ['core.deviceCharacteristics', 'core.privacyRestriction.userIsResident'],
        template: template
    };
    return generate(config, store, overrides, getDefaultOptions(store));
}

/**
 * Attach component events to DOM
 * @returns {undefined}
 */
export function attachEvents(store) {

    $(document).on('mouseenter', '.c-footer-promo', (e) => {
        $('#a-footer-promo-hover').attr('aria-hidden', 'false');
    });

    $(document).on('mouseleave', '.c-footer-promo', (e) => {
        $('#a-footer-promo-hover').attr('aria-hidden', 'true');
    });

    $(document).on(this.scopedEvent('touchend click'), '.js-user-order-status', (e) => {
        e.preventDefault();

        import('@core/js/sagas/async/orderStatusSagas').then(({ orderStatusActionSaga }) => {
            store.runSaga(orderStatusActionSaga);
        });
    });

    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-footer-email-signup'), (e) => {
        e.preventDefault();
        launchAsyncEmailSignUpModal(e,
            this.name,
            'modal',
            _.get(
                store.getState(),
                'core.featureConfigs.footerAnonymousEmailSubscriptions.source',
                'Site Footer'
            )
        );
    });

    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-site-language-change'), (e) => {
        clearUniqueVisitsCookie();

        const localeURL = $(e.currentTarget).attr('data-locale-url');
        const linkLocation = $(e.currentTarget).attr('href');

        if (localeURL) {
            e.preventDefault();
            const countryCode = extractCountryCodeFromFooterSiteURL(localeURL);

            store.runSaga(getDefaultCurrencyForCountry, countryCode).done.then((defaultCurrency) => {
                if (defaultCurrency && _.size(defaultCurrency) > 0) {
                    Cookies.setCookie(COOKIE_NAME_COUNTRY, countryCode);
                    changeCurrency(defaultCurrency, undefined, false);
                }
            }).catch((err) => {
                logError(`Error looking up currency info for ${countryCode}`, err);
            }).then(() => {  // finally case
                window.location = linkLocation;
            });
        }
    });
}

export function afterRender(store) {
    optionallyAddAccordionSupport.bind(this)(store);
}

export function onStateChange(store, watchValue, previous, current) {

    if (watchValue === 'core.privacyRestriction.userIsResident') {
        getFlatNavigationSync(store);
    }
    this.render(store, this, {});
}
